import React, { useContext } from "react";
import AirportShuttleOutlinedIcon from "@mui/icons-material/AirportShuttleOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

export default function TiposMoviles() {
  const {
    tiposMoviles,
    obtenerTiposMoviles,
    agregarTipoMovil,
    actualizarTipoMovil,
  } = useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Tipos de Móviles"
      entidad="tipo de móvil"
      layout="TiposMoviles"
      icono={<AirportShuttleOutlinedIcon />}
      items={tiposMoviles}
      onObtener={() => obtenerTiposMoviles({ todos: true })}
      onAgregar={(data) => agregarTipoMovil({ tipoMovil: data })}
      onActualizar={(data) => actualizarTipoMovil({ tipoMovil: data })}
    />
  );
}
